import { Component, EventEmitter, output, Output } from '@angular/core';
import { ZzMenu, ZzMenuTree } from 'src/app/zz/zz-menu/shared/zz-menu';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class AppMenuComponent{
  items$: ZzMenuTree[] = [];
  menuOut = output<any>()
  constructor() {}
  buttonClick(item: ZzMenu){
    this.menuOut.emit(item);
  }
  setItems(items: ZzMenuTree[]){
    if (items && items.length > 0){
      this.items$ = [...items];
    }
    else{
      this.items$ = [];
    }
  }
}
